export default __webpack_public_path__ + "static/media/no-comments-activity.384ac99b.svg";